import React from 'react';

import PropTypes from 'prop-types';

export default function PlusIcon2({
  width = 8,
  height = 8,
  color = '#1B1C19',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 8 8"
      fill="none"
      {...rest}
    >
      <path
        d="M8 4C8 4.08841 7.96488 4.17319 7.90237 4.2357C7.83986 4.29821 7.75507 4.33333 7.66667 4.33333H4.33333V7.66667C4.33333 7.75507 4.29821 7.83986 4.2357 7.90237C4.17319 7.96488 4.08841 8 4 8C3.91159 8 3.82681 7.96488 3.7643 7.90237C3.70179 7.83986 3.66667 7.75507 3.66667 7.66667V4.33333H0.333333C0.244928 4.33333 0.160143 4.29821 0.0976311 4.2357C0.035119 4.17319 0 4.08841 0 4C0 3.91159 0.035119 3.82681 0.0976311 3.7643C0.160143 3.70179 0.244928 3.66667 0.333333 3.66667H3.66667V0.333333C3.66667 0.244928 3.70179 0.160143 3.7643 0.0976311C3.82681 0.035119 3.91159 0 4 0C4.08841 0 4.17319 0.035119 4.2357 0.0976311C4.29821 0.160143 4.33333 0.244928 4.33333 0.333333V3.66667H7.66667C7.75507 3.66667 7.83986 3.70179 7.90237 3.7643C7.96488 3.82681 8 3.91159 8 4Z"
        fill={color}
      />
    </svg>
  );
}

PlusIcon2.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
